import { render, staticRenderFns } from "./orderPerformersEdit.vue?vue&type=template&id=3283f9eb&"
import script from "./orderPerformersEdit.vue?vue&type=script&lang=js&"
export * from "./orderPerformersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports